const paymentRoutes = {
  payments: {
    path: '/payments'
  },
  adminSubscriptions: {
    path: '/subscriptions'
  },
  adminCoupons: {
    path: '/coupons'
  },
  listClientPayments: {
    administrator: {
      path: '/payments/clients'
    },
    client: {
      path: '/payment-history'
    }
  },
  clientChargesHistory: {
    path: '/payment-history/charges'
  },
  listTrainerPayments: {
    administrator: {
      path: '/payments/trainers'
    },
    trainer: {
      path: '/payments/trainer'
    }
  },
  createClientPayment: {
    path: '/payments/clients/create'
  },
  createTrainerPayment: {
    path: '/payments/trainers/create'
  },
  editClientPayment: {
    path: '/payments/clients/:id'
  },
  editTrainerPayment: {
    path: '/payments/trainers/:id'
  }
};

export default paymentRoutes;
